<template>
	<div class="videoArea" v-show="isShow">
    <video ref="videoPlayer" class="video-js vjs-nofull" controls preload="auto"></video>
  </div>
</template>

<script>
import videojs from 'video.js';
export default {
	data(){
		return {
		 	player: null,
      isShow: false
    }
	},
  props: {
    src: {
      type: String,
      default: ''
    }
  },
  watch: {
    src: {
      handler(url) {
        console.log(url, 999)
        this.$nextTick(() => {
          this.videoChange(url)
        })
      },
      immediate: true
    }
  },
	methods: {
		// 实例化播放器
		createVideo(){
			let options = {
        autoplay: false,
        controls: true,
        sources: [
            {
              src: this.src + '?rnd='+new Date(),
            }
        ],
        html5: {
          nativeTextTracks: false
        }
      }
      const vm = this
      vm.isShow = false
      this.player = videojs(this.$refs.videoPlayer, options, function onPlayerReady() {
        console.log('onPlayerReady', this)
        const timer = setTimeout(() => {
          vm.isShow = true
          clearTimeout(timer)
        }, 200)
      })

    },
    // 关闭声音
    puse() {
      this.player.pause() //暂停
      this.player.currentTime(0) //复位
    },
    videoChange(url) {
      if (this.player) {
        setTimeout(() => {
          url && this.player.src({src: url})
        }, 100)
      } else {
        url && this.createVideo()
      }

    }
	},
	mounted() {
	  this.createVideo()
	},
}
</script>

<style lang="scss">
.videoArea {
  .video-js {
    max-width: 600px;
    max-height: 500px;
    &.vjs-nofull {
      .vjs-fullscreen-control {
        display:none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/common/VideoModel/index.vue?81af91e6